module.exports = __webpack_public_path__ + "media/images/thumbs/biology/v_qv_animal_structure_and_function_1-edfb020345e3f324e5e99a7897475ed0.jpg";